import React from 'react';
import { Zoom, useTheme, Fab } from '@material-ui/core';

const FloatButton = ({
  mainTabID,
  fabs,
  onaddNewJourney,
  onaddNewDealership,
  onaddNewDaily,
  onAddNewPlan,
  onAddNewCollection,
  onAddNewLeaderboard,
  onAddNewInapp,
  onAddNewCustomGroup,
  onAddNewRule,
  onaddNewTopic,
  onAddNewCert,
  onAddNewExerciseCat,
  onAddNewContest,
  onaddNewQuizSeries,
  onAddNewAdminUser,
  value,
}) => {
  const theme = useTheme();
  const transitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen,
  };
  const add = () => {
    if (mainTabID === 0) onaddNewJourney();
    else if (mainTabID === 1) onaddNewDealership();
    else if (mainTabID === 2) onaddNewDaily();
    else if (mainTabID === 3) onAddNewPlan();
    else if (mainTabID === 8) onAddNewLeaderboard();
    else if (mainTabID === 9) onAddNewInapp();
    else if (mainTabID === 10) onAddNewCustomGroup();
    else if (mainTabID === 11) onAddNewRule();
    else if (mainTabID === 16) onaddNewTopic();
    else if (mainTabID === 17) onAddNewCert();
    else if (mainTabID === 18) onAddNewExerciseCat();
    else if (mainTabID === 19) onAddNewContest();
    else if (mainTabID === 22) onaddNewQuizSeries();
    else if (mainTabID === 23) onAddNewAdminUser();
    else onAddNewCollection();
  };
  return (
    <div>
      {fabs.map((fab, index) => (
        <Zoom
          in={value === index}
          timeout={transitionDuration}
          style={{
            transitionDelay: `${value === index ? transitionDuration.exit : 0}ms`,
            position: 'fixed',
            bottom: '2em',
            left: '14em',
          }}
          unmountOnExit
        >
          <Fab aria-label={fab.label} className={fab.className} color={fab.color} onClick={add}>
            {fab.icon}
          </Fab>
        </Zoom>
      ))}
    </div>
  );
};

export default FloatButton;
